export default __webpack_public_path__ + "static/media/coded-wordmark-navy.c5a5c452.webp";